import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-foreground-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-gift-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">注册送彩金</span>
            </div>
            <p className="text-foreground-300 text-sm leading-relaxed">
              国内领先的游戏娱乐福利平台，致力于为广大玩家提供最优质的注册彩金福利和游戏资讯服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors duration-200">首页</Link>
              <Link to="/category/slot-games" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors duration-200">游戏分类</Link>
              <Link to="/article/1" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors duration-200">攻略文章</Link>
              <Link to="/about" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors duration-200">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/slot-games" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors duration-200">电子游艺</Link>
              <Link to="/category/table-games" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors duration-200">棋牌游戏</Link>
              <Link to="/category/live-casino" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors duration-200">真人娱乐</Link>
              <Link to="/category/sport-betting" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors duration-200">体育竞技</Link>
              <Link to="/category/lottery" className="text-foreground-300 text-sm hover:text-primary-400 transition-colors duration-200">彩票游戏</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2.5 text-foreground-300 text-sm">
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-8888</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>service@zhucecaijin.com</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400"></i>
                <span>周一至周日 09:00-24:00</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800/30 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; {new Date().getFullYear()} 注册送彩金 版权所有 | 仅供娱乐参考
          </p>
          <div className="flex items-center gap-4 text-foreground-400 text-xs">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">服务条款</a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}